import type { FaireProductEntity } from "../../entity_types/product";

export const p_m35zmwq8r6: FaireProductEntity = {
  token: "p_m35zmwq8r6",
  type: "product",
  name: "WOODLAND WANDER • 100% BOTANICAL BATH BOMB",
  brandToken: "b_9defb7f0",
  brandName: "Ginger June Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/6f68a2911364e2153caa86d55caba2185cd25a12979f8ac0ce7538a5f769a369.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description:
    "5.5 oz herb + flower infused bath bomb.\nzero synthetic ingredients, nourishing & luxurious treat for your bath.\nhand made with so much love\n\ningredients: baking soda, citric acid, jojoba oil, avocado oil. witch hazel, cream of tartar, arrowroot, clay, cocoa butter, essential oils\n\nWoodland Wander\n\nessential oil blend of:  fir, cypress, cedar, balsam, eucalyptus, spearmint, sweet marjoram, rosemary, bergamot, frankincense\n",
  tags: [],
  msrpDollars: 10,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:13.890Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
